export const saodKeys = {
  base: ['saod'],
  forFirm: (firmID: string | undefined | null) => [
    ...saodKeys.base,
    'forFirm',
    firmID,
  ],
};
